import { ButtonProps, TextBlockProps, UseServer } from '@stadionhq-v3/base-ui';
import { DocumentLinks, Theme } from '@stadionhq-v3/core';
import { Options } from '@contentful/rich-text-react-renderer';
import { TextBlock } from '@graphql/__generated__/graphql';
import { CleanContentful } from '@stadionhq-v3/clean-contentful';
import { Locale } from '@core/constants/locales.constants';
import ContentfulRichTextRenderer from '@components/helpers/contentful-rich-text-render';
import { isLink } from '@core/types/typeGuards';
import { renameKeyFromTitleToText } from '@utils/objects.utils';
import { linkTransform } from '../atoms';

export type TextBlockTransformSettings = {
  richTextRenderOptions?: Options;
};

const textBlockTransform = (
  {
    title,
    subTitle,
    introParagraph,
    bodyCopy,
    links,
    theme,
  }: CleanContentful<TextBlock>,
  locale: Locale
): TextBlockProps => ({
  showTitle: true,
  title,
  subTitle,
  introParagraph,
  theme: (theme as Theme) || undefined,

  links: links
    ?.filter(isLink)
    ?.map((link) =>
      renameKeyFromTitleToText(linkTransform(link, locale))
    ) as ButtonProps[],

  bodyCopy: (
    <UseServer>
      <ContentfulRichTextRenderer
        document={{
          json: bodyCopy?.json,
          links: bodyCopy?.links as DocumentLinks,
        }}
        theme={(theme as Theme) || undefined}
      />
    </UseServer>
  ),
});

export default textBlockTransform;
